const ROLE_TO_CATEGORY = {
    MILK_DONOR: "md"
};

export const getCategoryByRole = (role) => {
    const category = ROLE_TO_CATEGORY[role];
    if (!category) {
        throw new Error(`No file category configured for role: ${role}`);
    }
    return category;
};
